/* eslint-disable */
import React, { useState } from "react";
import {
  Modal,
  Box,
  Group,
  Text,
  Button,
  ThemeIcon,
  Title,
  Center,
  useMantineTheme,
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

type DeleteUserProps = {
  deleteOpen: boolean;
  onClose: () => void;
  roleId?: string;

  onConfirm?: (roleId?: string) => Promise<any> | void;

  onDeleted?: (roleId?: string) => void;
  title?: string;
  message?: string;
};

export default function DeleteUser({
  deleteOpen,
  onClose,
  roleId,
  onConfirm,
  onDeleted,
  title = "Confirm Delete",
  message = "You want to delete all the marked items, this cant be undone once you delete.",
}: DeleteUserProps) {
  const theme = useMantineTheme();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (loading) return;
    setLoading(true);
    try {
      if (onConfirm) {
        const res = onConfirm(roleId);
        if (res && typeof (res as any).then === "function") {
          await res;
        }
      } else {
        console.warn("DeleteUser: no onConfirm provided.");
      }

      if (onDeleted) onDeleted(roleId);
      onClose();
    } catch (err) {
      console.error("Delete failed:", err);

      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      opened={deleteOpen}
      onClose={() => {
        if (!loading) onClose();
      }}
      centered
      withCloseButton={false}
      overlayOpacity={0.5}
      size="md"
      padding="lg"
      transitionDuration={180}
      radius="md"
    >
      <Box style={{ padding: 8 }}>
        <Center>
          <ThemeIcon
            size={72}
            radius="md"
            variant="filled"
            style={{
              background: "#fdecec",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconTrash size={32} stroke={1.5} style={{ color: "#e53e3e" }} />
          </ThemeIcon>
        </Center>

        <Title
          order={4}
          align="center"
          style={{ marginTop: 18, marginBottom: 8, fontWeight: 700 }}
        >
          {title}
        </Title>

        <Text
          align="center"
          size="sm"
          color="dimmed"
          style={{ maxWidth: 520, margin: "0 auto 18px", lineHeight: 1.6 }}
        >
          {message}
        </Text>

        <Group position="center" spacing="md" mt={6}>
          <Button
            // variant="light"
            color="cancel"
            onClick={() => {
              if (!loading) onClose();
            }}
            disabled={loading}
            // sx={(t) => ({
            //   minWidth: 120,
            //   backgroundColor: t.colors.gray[0],
            //   color: t.colors.dark[7],
            //   borderRadius: 8,
            // })}
          >
            Cancel
          </Button>

          <Button
            onClick={handleConfirm}
            loading={loading}
            // color="red"
            // sx={{
            //   minWidth: 140,
            //   borderRadius: 8,
            //   backgroundColor: theme.colors.red[6],
            // }}
          >
            Yes, Delete
          </Button>
        </Group>
      </Box>
    </Modal>
  );
}
